interface ButtonProps {
  buttonText: string;
  icon?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({
  buttonText,
  icon,
  className = "",
  onClick,
}) => {
  return (
    <button
      className={`rounded-full flex  items-center transition-all  ${className}`}
      onClick={onClick}
    >
      {icon && <span className="mr-1">{icon}</span>}
      {buttonText}
    </button>
  );
};

export default Button;
